import Navbar from "./Navbar";
import Footer from "./Footer";
import ChatWidget from "./ChatWidget";
import MobileActionBar from "./MobileActionBar";
import GoogleReviews from "./GoogleReviews";

export default function Layout({ children }) {
  return (
    <div className="App">
      <Navbar />
      <main className="pb-16 lg:pb-0">{children}</main>
      <GoogleReviews />
      <Footer />
      <ChatWidget />
      <MobileActionBar />
    </div>
  );
}
